export default __webpack_public_path__ + "static/media/image3.86d7f2ac.png";